export interface Citation {
  id: string;
  source: string;
  url?: string;
  description: string;
}

export type CitationsMap = Record<string, Citation>;

export const citations: CitationsMap = {
  zillow: {
    id: 'zillow',
    source: 'Zillow Zestimate',
    url: 'https://www.zillow.com/homedetails/2040-Beryl-Ln-Newport-Beach-CA-92660/25212911_zpid/',
    description: 'Automated valuation model estimate as of December 2025'
  },
  redfin: {
    id: 'redfin',
    source: 'Redfin Estimate',
    url: 'https://www.redfin.com/CA/Newport-Beach/2040-Beryl-Ln-92660/home/3558891',
    description: 'Redfin AVM estimate as of December 2025'
  },
  caseShillerLA: {
    id: 'csla',
    source: 'S&P Case-Shiller LA Index',
    url: 'https://fred.stlouisfed.org/series/LXXRSA',
    description: 'Los Angeles metro area home price index from Federal Reserve Economic Data'
  },
  caseShillerNational: {
    id: 'csnat',
    source: 'S&P Case-Shiller National Index',
    url: 'https://fred.stlouisfed.org/series/CSUSHPINSA',
    description: 'National home price index since 1987'
  },
  sp500: {
    id: 'sp500',
    source: 'S&P 500 Historical Returns',
    url: 'https://www.slickcharts.com/sp500/returns',
    description: 'Historical annual returns data'
  },
  nyuStern: {
    id: 'nyu',
    source: 'NYU Stern Historical Data',
    url: 'https://pages.stern.nyu.edu/~adamodar/New_Home_Page/datafile/histretSP.html',
    description: 'Comprehensive stock and bond returns by decade'
  },
  shillerCAPE: {
    id: 'cape',
    source: 'Shiller CAPE Ratio',
    url: 'https://www.multpl.com/shiller-pe/table/by-month',
    description: 'Cyclically adjusted price-to-earnings ratio'
  },
  investopedia: {
    id: 'investopedia',
    source: 'Investopedia',
    url: 'https://www.investopedia.com/ask/answers/042415/what-average-annual-return-sp-500.asp',
    description: 'Average S&P 500 returns analysis'
  },
  apartmentList: {
    id: 'aptlist',
    source: 'Apartment List',
    url: 'https://www.apartmentlist.com/rent-report/ca/newport-beach',
    description: 'Newport Beach rental market data'
  },
  nasdaq: {
    id: 'nasdaq',
    source: 'NASDAQ Performance Analysis',
    url: 'https://www.nasdaq.com/nasdaq100-vs-sp500-performance',
    description: 'NASDAQ-100 vs S&P 500 comparison'
  },
  longtermTrends: {
    id: 'ltt',
    source: 'Long Term Trends',
    url: 'https://www.longtermtrends.com/home-price-vs-inflation/',
    description: 'Historical home price vs inflation analysis'
  },
  realEstateDecoded: {
    id: 'red',
    source: 'Real Estate Decoded',
    url: 'https://realestatedecoded.com/case-shiller/',
    description: 'Interactive Case-Shiller charts'
  },
};
